import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaURLSearchParamsDefinition } from './TypedDefinition'

export const SchemaURLSearchParamsPlugin = createSchemaPlugin(
  'Schema.URLSearchParams',
  SchemaURLSearchParamsDefinition
)
